export default __webpack_public_path__ + "static/media/0036.e9fc1b13.png";